// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".label-name--input[data-v-70baf776] input {\n    text-transform: lowercase\n}", "",{"version":3,"sources":["/app/app/javascript/dashboard/routes/dashboard/settings/labels/AddLabel.vue"],"names":[],"mappings":"AAKM;IAAA;AAAA","file":"AddLabel.vue","sourcesContent":["\n// Label API supports only lowercase letters\n.label-name--input {\n  ::v-deep {\n    input {\n      @apply lowercase;\n    }\n  }\n}\n"]}]);
// Exports
module.exports = exports;
